import { FC, ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { MultiSelect as JbcMultiSelect, Option } from 'jbc-front/components/presenters/form/Select';

type MultiSelectFieldProps = ComponentProps<typeof JbcMultiSelect> & {
  name: string;
};

export const MultiSelect: FC<MultiSelectFieldProps> = ({ options, name, ...selectProps }) => {
  const { control } = useFormContext();

  const { field } = useController({
    name,
    control
  });

  const handleChange = (option: Option[]) => {
    field.onChange(option.map(option => option.value));
  };

  const handleBlur = () => {
    field.onBlur();
  };

  return (
    <JbcMultiSelect
      {...selectProps}
      options={options}
      onChange={handleChange}
      onBlur={handleBlur}
      value={options.filter((option: Option) => field.value?.includes(option.value))}
    />
  );
};
